/* ==========================================================================
   International Registry of Lethal Hands - Results email capture
   Reads the outcome from the results screen, tags the signup, and posts
   to Shopify's customer form without leaving the page.
   ========================================================================== */

(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lhCaptureReady === 'true') return;

    var capture = root.querySelector('[data-lh-capture]');
    var results = root.querySelector('[data-lh-screen="results"]');
    if (!capture || !results) return;

    var form = capture.querySelector('form');
    var input = capture.querySelector('input[type="email"]');
    var tagsEl = capture.querySelector('[data-lh-capture-tags]');
    var heading = capture.querySelector('[data-lh-capture-heading]');
    var sub = capture.querySelector('[data-lh-capture-sub]');
    var msg = capture.querySelector('[data-lh-capture-msg]');
    var row = capture.querySelector('[data-lh-capture-row]');
    var submit = capture.querySelector('[data-lh-capture-submit]');
    var scoreEl = root.querySelector('[data-lh-score]');
    var actions = root.querySelector('[data-lh-result-actions]');
    if (!form || !input || !tagsEl) return;

    root.dataset.lhCaptureReady = 'true';

    var d = capture.dataset;
    var done = false;

    /* Eligible results render a register link; deferred render a button. */
    function outcome() {
      var eligible = !!(actions && actions.querySelector('a.lh-btn'));
      var score = parseInt(scoreEl ? scoreEl.textContent : '', 10);
      return { eligible: eligible, score: isNaN(score) ? null : score };
    }

    function refresh() {
      if (done) return;
      var o = outcome();
      if (heading) heading.textContent = o.eligible ? d.headingEligible : d.headingDeferred;
      if (sub) sub.textContent = o.eligible ? d.subEligible : d.subDeferred;
      capture.classList.toggle('is-eligible', o.eligible);

      var tags = ['quiz', 'quiz-' + (d.quiz || 'quiz'), o.eligible ? 'eligible' : 'deferred'];
      if (o.score !== null) tags.push('score-' + o.score);
      tagsEl.value = tags.join(', ');
    }

    function setMessage(text, isError) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.toggle('is-error', !!isError);
    }

    function succeed() {
      done = true;
      capture.classList.add('is-done');
      if (row) row.hidden = true;
      if (sub) sub.hidden = true;
      setMessage(d.success, false);
    }

    function fail() {
      if (submit) submit.disabled = false;
      setMessage(d.error, true);
    }

    form.addEventListener('submit', function (event) {
      if (!window.fetch || !window.FormData || !window.DOMParser) return; // native post
      event.preventDefault();
      if (!input.value || !input.checkValidity()) {
        input.reportValidity && input.reportValidity();
        return;
      }

      refresh();
      if (submit) submit.disabled = true;
      setMessage('', false);

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then(function (res) {
          /* Shopify bot protection: hand off to a normal post so the
             visitor can complete the challenge. */
          if (/\/challenge/.test(res.url)) {
            form.submit();
            return null;
          }
          if (!res.ok) throw new Error('status ' + res.status);
          return res.text();
        })
        .then(function (html) {
          if (html === null || html === undefined) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var err = doc.querySelector('#' + form.id + ' [data-lh-capture-err]');
          if (err && !/taken/i.test(err.textContent)) {
            fail();
            return;
          }
          /* Success marker, an already-subscribed address, or a redirect
             with customer_posted all count as on the list. */
          succeed();
        })
        .catch(fail);
    });

    refresh();
    if (results.classList.contains('is-active')) refresh();

    new MutationObserver(function () {
      if (results.classList.contains('is-active')) refresh();
    }).observe(results, { attributes: true, attributeFilter: ['class'] });

    /* After a native post (challenge fallback) the page reloads at the intro.
       Confirm the signup there so it isn't silently lost. */
    if (capture.querySelector('[data-lh-capture-ok]') && /customer_posted=true/.test(location.search)) {
      succeed();
      var intro = root.querySelector('[data-lh-screen="intro"] .lh-intro');
      if (intro) {
        var note = document.createElement('p');
        note.className = 'lh-capture-banner';
        note.setAttribute('role', 'status');
        note.textContent = d.success;
        intro.insertBefore(note, intro.firstChild);
      }
    }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-lh-root]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
